import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LotsService } from '../../../../../shared/lots.service';
import { Lot } from '../../../../../models/lot-model';
import { ShipmentsKpi } from '@models/shipments-kpi';
import { ShipmentsService } from '@shared/shipments.service';

@Component({
  selector: 'app-shipments-kpi',
  templateUrl: './shipments-kpi.component.html',
  styleUrls: ['./shipments-kpi.component.css'],
})
export class ShipmentsKpiComponent implements OnInit {
  constructor(private lotsService: LotsService, private shipmentsService: ShipmentsService, private router: Router) {}

  currentLot: Observable<Lot>;
  kpiData: Observable<ShipmentsKpi>;

  ngOnInit() {
    this.currentLot = this.lotsService.lotSubject;
    this.kpiData = this.shipmentsService.shipKpiData;
  }

  goBack() {
    this.router.navigate(['/lots']);
  }
}
